export enum OrderStatusTrackingCodeEnum {
    All,
    WithTrackingCode,
    WitoutTrackingCode,
}
